/**
 * Shared score and tier color constants.
 *
 * SCORE_CLASSES maps 1-5 source scores to CSS class names (pill styling).
 * TIER_COLORS maps 1-5 article tiers to hex/CSS color values.
 *
 * TIER_COLORS is the webapp half of the cross-client tier-color scale: the
 * mobile halves are ios/Kingfisher/TierColors.swift and
 * android/.../ui/components/TierColors.kt, and
 * backend/tests/test_mirror_parity.py pins the three ramps equal so the same
 * article can't wear a different quality color per client. Retune the shades
 * here and in both mirrors in one commit.
 */

export const SCORE_CLASSES: Record<number, string> = {
  1: 'score-1',
  2: 'score-2',
  3: 'score-3',
  4: 'score-4',
  5: 'score-5',
};

export const TIER_COLORS: Record<number, string> = {
  1: '#ef4444',
  2: '#f97316',
  3: '#eab308',
  4: '#22c55e',
  5: '#10b981',
};

export function tierColor(tier: number | undefined): string {
  if (tier == null) return 'var(--muted)';
  return TIER_COLORS[tier] ?? 'var(--muted)';
}

export function scoreClass(score: number | undefined | null): string {
  if (score == null) return '';
  return SCORE_CLASSES[score] ?? '';
}
